export const countWords = (str: string): number => {
  const trimmedStr = str?.trim();
  return trimmedStr === '' ? 0 : trimmedStr?.split(/\s+/).length;
};
